import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import GoBack from "../../components/goBack";
import Select from "react-select";
import axios from "axios";
import $ from "jquery";
import { baseURL } from "../../services/api";
import OrgContext from "../../organisation/OrgContext";
import AuthContext from "../../components/shared/AuthContext";
import Swal from "sweetalert2";
import { useTranslation } from "react-i18next";
import { toast, ToastContainer } from "react-toastify";
import moment from "moment/moment";
import NewClient from "../Items/NewClient";
import useAuthHelper from "../../helpers/AuthHelper";

export const DetailsBoncommande = () => {
  const { organisation } = useContext(OrgContext);
  const { user } = useContext(AuthContext);
  const [t] = useTranslation();
  const { id } = useParams(); // Get BonCommande ID from route params
  const navigate = useNavigate();

  // State variables
  const [suppliers, setSuppliers] = useState([]);
  const [products, setProducts] = useState([]);
  const [selectedSupplier, setSelectedSupplier] = useState(null);
  const [orderProducts, setOrderProducts] = useState([]);
  const [orderDate, setOrderDate] = useState(moment().format("YYYY-MM-DD"));
  const [isSubmit, setIsSubmit] = useState(false);

  // Modal states
  const [productIdToEdit, setProductIdToEdit] = useState(0);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [qty, setQty] = useState(0);
  const [unitPrice, setUnitPrice] = useState(0);
  const [totalHt, setTotalHt] = useState(0);
  const [totalTtc, setTotalTtc] = useState(0);
  const [tva, setTva] = useState(0);
  const [productDetails, setProductDetails] = useState("");
  const leTotalHt = useRef(0);
  const leTotalTtc = useRef(0);
  const [singleSelectedProduct, setSingleSelectedProduct] = useState([]);
  const [isService, setIsService] = useState(false);
  const [invoiceProductsState, setInvoiceProductsState] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [selectedProductQty, setSelectedProductQty] = useState(0);
  const [totalTTc, setTotalTTC] = useState();
  const [dueDate, setDueDate] = useState();
  const [title, setTitle] = useState();
  const leTotalTTc = useRef(0);
  // Summary
  const [summaryTotatlHt, setSummaryTotalHt] = useState(0);
  const [summaryTotalTva, setSummaryTotalTva] = useState(0);
  const [summaryTotatlTtc, setSummaryTotalTtc] = useState(0);

  // Fetch suppliers
  const fetchSuppliers = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/client/getbyuser/${user.id}/fournisseurs/${organisation.id}`
      );
      setSuppliers(
        response.data.data.map((s) => ({
          value: s.id,
          label: s.companyName,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch products
  const fetchProducts = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/product/getbyuser/${user.id}/${organisation.id}`
      );
      setProducts(
        response.data.data.map((p) => ({
          value: p.id,
          label: p.name,
          tva: p.taxe_achat.rate,
          unitPrice: p.costPrice,
        }))
      );
    } catch (error) {
      console.error(error);
    }
  };

  // Fetch existing BonCommande data
  const fetchBonCommande = async () => {
    try {
      const response = await axios.get(
        `${baseURL}/data/bon-commande-details/${id}`
      );
      const data = response.data;

      // Populate state with fetched data
      setSelectedSupplier({
        value: data.fournisseur.id,
        label: data.fournisseur.companyName,
      });
      setTitle(data.title);
      setOrderDate(moment(data.order_date).format("YYYY-MM-DD"));
      setDueDate(moment(data.due_date).format("YYYY-MM-DD"));
      console.log("data ord", orderDate);
      console.log("data due", dueDate);
      setInvoiceProductsState(
        data.bon_commande_products.map((p) => ({
          id: p.id,
          product_id: p.product_id,
          name: p.product.name,
          qty: p.qty,
          unitPrice: p.price_unit_ht,
          tva: p.tva,
          totalHt: p.total_ht,
          totalTtc: p.total_ttc,
          details: p.details,
        }))
      );
      updateSummary(data.products);
    } catch (error) {
      console.error("Error fetching BonCommande:", error);
    }
  };


  useEffect(() => {
    fetchSuppliers();
    fetchProducts();
    fetchBonCommande(); // Fetch existing data
  }, []);



  // Update summary
  const updateSummary = (products) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    products.forEach((product) => {
      totalHt += product.totalHt;
      totalTva += product.totalTtc - product.totalHt;
      totalTtc += product.totalTtc;
    });

    setSummaryTotalHt(totalHt.toFixed(2));
    setSummaryTotalTva(totalTva.toFixed(2));
    setSummaryTotalTtc(totalTtc.toFixed(2));
  };

  useEffect(() => {
    fetchSuppliers();
    fetchProducts();
  }, []);


  useEffect(() => {
    calcInvoiceSummary(invoiceProductsState);
  }, [invoiceProductsState]);

  const calcInvoiceSummary = (invoiceProducts) => {
    let totalHt = 0;
    let totalTva = 0;
    let totalTtc = 0;

    for (let i = 0; i < invoiceProductsState.length; i++) {
      totalHt += parseFloat(invoiceProductsState[i].totalHt);
      totalTtc += parseFloat(invoiceProductsState[i].totalTtc);
      totalTva +=
        parseFloat(invoiceProductsState[i].totalTtc) -
        parseFloat(invoiceProductsState[i].totalHt);
    }
    setSummaryTotalHt(totalHt);
    setSummaryTotalTva(totalTva);
    setSummaryTotalTtc(totalTtc);
  };


  const { onlyCommercial } = useAuthHelper();

  useEffect(() => {
    onlyCommercial();

    $(".all-fields-are-required-to-save").css("display", "none");
    $("#warning-create-client-first").css("display", "none");
    $("#table-rows").css("display", "none");
    $("#all-fields-are-required").css("display", "none");
    $("#warning-product-already-exists").css("display", "none");
    $("#qty-is-higher").css("display", "none");
    $(".some-fields-are-required-to-save").css("display", "none");
  }, []);

  return (
    <>
      <ToastContainer />
      <div className="main-container container-fluid">
        <GoBack route={"/achats/boncommande/list"} />
        <div className="page-header">
          <h1 className="page-title">{t("Détails du Bon de Commande")}</h1>
        </div>
        <div className="card">
          <div className="card-body">
            <h4>{t("Espace Fournisseur")}</h4>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Fournisseur")}</label>
                  <Select
                    options={suppliers}
                    value={selectedSupplier}
                    isDisabled={true} // Désactiver le Select
                  />
                </div>
              </div>
            </div>
            <hr />
            <h4>{t("Informations sur la facture")}</h4>
            <hr />
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Numéro de bon de commande")}</label>
                  <input
                    type="text"
                    value={title}
                    className="form-control"
                    readOnly // Champ en lecture seule
                  />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>{t("Date bon de commande")}</label>
                  <input
                    type="date"
                    className="form-control"
                    value={orderDate}
                    readOnly // Champ en lecture seule
                  />
                </div>
                <div className="form-group">
                <label>{t("Date date d'échéance*")}</label>
                  <input
                    type="date"
                    className="form-control"
                    value={dueDate}
                    readOnly // Champ en lecture seule
                  />
                </div>
              </div>
            </div>
            <hr />
            <h4>{t("Détails Produits")}</h4>
            <hr />
            <table className="table">
              <thead>
                <tr>
                  <th scope="col">DÉTAILS DE L’ARTICLE</th>
                  <th scope="col">QUANTITÉ</th>
                  <th scope="col">PU HT</th>
                  <th scope="col">TVA %</th>
                  <th scope="col">Total HT</th>
                  <th scope="col">Total TTC</th>
                </tr>
              </thead>
              <tbody>
                {invoiceProductsState.map((product) => (
                  <tr key={product.product_id}>
                    <td>{product.name}-{product.details}</td>
                    <td>{product.qty}</td>
                    <td>{product.unitPrice}</td>
                    <td>{product.tva + "%"}</td>
                    <td>{product.totalHt}</td>
                    <td>{product.totalTtc}</td>
                  </tr>
                ))}
              </tbody>
            </table>
            <hr className={"custom-hr"} />
            <div className={"row"}>
              <div className={"col-md-6"}></div>
              <div className={"col-md-6 d-flex flex-row-reverse"}>
                <div className="row">
                  <div className="invoiceSummary">
                    <table>
                      <tr>
                        <td className={"invoiceSummary-base"}>Total HT :</td>
                        <td>
                          {Number(summaryTotatlHt).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </td>
                      </tr>
                      <tr>
                        <td className={"invoiceSummary-base"}>Total TVA :</td>
                        <td>
                          {Number(summaryTotalTva).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </td>
                      </tr>
                      <tr>
                        <td className={"invoiceSummary-base"}>Total TTC :</td>
                        <td>
                          {Number(summaryTotatlTtc).toFixed(2)}{" "}
                          {organisation?.currency?.code}
                        </td>
                      </tr>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};